import { Component, Injector, Optional, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AlertService } from './alert.service';
import { Alert } from './alert';
import { PagedCollectionComponent, ColumnDefinition, Filter, createColumnDefinitions, MgTableComponent } from '@mango/core';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '@mango/authentication';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell } from '@angular/material/table';
import { DatePipe } from '@angular/common';


@Component({
    selector: 'dla-app-alert-collection',
    templateUrl: './alert-collection.component.html' /*,
    styleUrls: ['./alert-collection.component.css'] */,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MgTableComponent, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, DatePipe]
})
export class AlertCollectionComponent extends PagedCollectionComponent<Alert> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Alert>([
		'title',
		'message',
		'date',
		'type',
		'expiringDate',
        {colDef: null, prop: x => x.receivedBy.id }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    currentUserId: number;

    constructor(public service: AlertService, private authService: AuthenticationService, @Optional() protected filter: Filter<Alert>, injector: Injector) {
        super('/alerts', Alert);

        if(!this.filter) {
            this.filter = new Filter<Alert>();
        }
    }

    ngOnInit() {
        super.ngOnInit();

        this.currentUserId = +this.authService.currentUser.id;
        this.service.hubSubject.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
            if (data == null || data == this.currentUserId) {
                this.dataSource.update();
            }
        });
    }
    

}